import { Redirect } from 'expo-router'

export default function LegacyPlans() {
  return <Redirect href="/profile/plans" />
}
